import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  Breakpoint,
  BreakpointState,
  MediaQueryService,
  MenuService,
  SystemStatusService,
  FinePrints,
  FinePrintService,
  ONE_TRUST_CONFIGURATION,
  OneTrustConfiguration
} from '@tdwb/core';

// eslint-disable-next-line td-wb-rules/change-detection-strategy-rule
@Component({
  selector: 'td-wb-layout',
  templateUrl: 'layout.component.html',
  styleUrls: ['layout.component.scss'],
  standalone: false
})

export class LayoutComponent implements OnInit, OnDestroy {

  breakpointChangesSubscription: Subscription;

  hasFinePrints: boolean;

  private systemAvailable: boolean;
  private isSmallScreen: boolean;

  get showManagePreferencesLink(): boolean {
    return this.oneTrustConfiguration?.oneTrustEnabled === true;
  }

  constructor(private mediaQueryService: MediaQueryService,
              private systemStatusService: SystemStatusService,
              private menuService: MenuService,
              private finePrintService: FinePrintService,
              @Optional() @Inject(ONE_TRUST_CONFIGURATION) private oneTrustConfiguration: OneTrustConfiguration) {
  }

  ngOnInit(): void {
    this.breakpointChangesSubscription = this.mediaQueryService.observe(Breakpoint.LT_MD)
      .subscribe((state: BreakpointState): void => {
        this.isSmallScreen = state.matches;
      });
    this.systemAvailable = this.systemStatusService.isSystemAvailable();
    this.finePrintService.onFinePrintUpdate.subscribe((finePrints: FinePrints): void => {
      Promise.resolve().then((): void => {
        this.hasFinePrints = Object.keys(finePrints).some((key: string): boolean => finePrints[key].length > 0);
      });
    });
  }

  ngOnDestroy(): void {
    if (this.breakpointChangesSubscription !== undefined) {
      this.breakpointChangesSubscription.unsubscribe();
    }
  }

  showDesktopMenu(): boolean {
    return !this.isSmallScreen;
  }

  showMobileMenu(): boolean {
    return this.isSmallScreen && this.isLocalMenuEnabled();
  }

  showFabMenu(): boolean {
    return this.isSmallScreen && this.isLocalMenuEnabled();
  }

  /**
   * This function returns enabled state of local menu
   *
   * @returns Returns true if local menu is enabled. Otherwise, false.
   */
  isLocalMenuEnabled(): boolean {
    return this.systemAvailable && this.menuService.isEnabled();
  }

  isFooterHidden(): boolean {
    return this.menuService.isFooterHidden();
  }
}
